import React, {Component, Fragment} from 'react'
import {Image, Form, TextField} from "../../styled"
import Logo from '../../../images/logo.png'
import LogoLogin from '../../../images/logo_login.png'
import { ReactComponent as Email } from 'images/icons/email2.svg'
import { ReactComponent as Facebook } from 'images/icons/facebook.svg'
import { ReactComponent as Instagram} from 'images/icons/instagram.svg'
import { ReactComponent as Linkedin } from 'images/icons/linkedin.svg'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import {Dialog} from '../../parts'
import {connect} from 'react-redux'
import {userLogin, forgotPassword, firstLogin} from '../../../store/actions/auth/email'
import {userLogout} from '../../../store/actions'
import {withSnackbar} from 'notistack'
import {ContainerForm,LoginConfig,Container,Header,BackImage,FormContainer} from './styled'
import { userAD } from '../../../store/actions/auth/login'
class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showPassword: false,
            password: '',
            email: '',
            keepLoggedIn: false,
            isInvalid: false,
            error: {},
            email_forgot: '',
            new_password: '',
            new_passwordRepeat: '',
            notRepeat: false
        }
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangeSelect = this.handleChangeSelect.bind(this)
        this.handleClickOpen = this.handleClickOpen.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleSubmitForgot = this.handleSubmitForgot.bind(this)
        this.handleSubmitChangePass = this.handleSubmitChangePass.bind(this)
    }

    componentDidMount() {
        const SSO = new URL(window.location.href).searchParams.get('auth_sso_token')
        if (SSO) {
            this.props.loginAD(SSO, this)
        }else {
            this.props.logout()
        }
    }

    handleSubmit(e) {
        e.preventDefault()
        let email = e.target.email,
            password = e.target.password

        const {isInvalid} = this.state,
            validUser = this.emailInput.validate(email),
            validPass = this.passwordInput.validate(password)

        if (validUser && validPass && !isInvalid && email.value !== 'leo.deomedesse@voicce.com.br') {
            //this.dialogBlocked.handleClickOpen()
            this.props.login(email.value, password.value,this)
        }
    }

    handleSubmitForgot(e) {
        e.preventDefault()
        let email = e.target.email_forgot
        const validEmail = this.emailForgotInput.validate(email)

        if (validEmail) {
            this.props.forgot_password(email.value, this)
        }
    }

    handleSubmitChangePass(e) {
        e.preventDefault()
        const newPass = e.target.new_password,
            PassRepeat = e.target.password_repeat,
            {email, password} = this,
            isDifferent = (newPass.value !== PassRepeat.value),
            validNewPassword = this.newPasswordInput.validate(newPass),
            validRepeat = this.passwordRepeatInput.validate(PassRepeat)

        this.setState({notRepeat: isDifferent})
        if (!isDifferent && validNewPassword && validRepeat ) {
            this.props.first_login(email,password,newPass.value,PassRepeat.value)
        }
    }

    handleChange(name, value, isInvalid) {
        this[name] = value
        this.setState({isInvalid})
    }

    handleChangeSelect(e) {
        const target = e.target;
        const name = target.name
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        })
    }

    handleClickShowPassword() {
        this.setState(prevState => ({showPassword: !prevState.showPassword}));
    }

    handleClickOpen() {
        this.setState(prevState => ({open: !prevState.open}));
    }

    render() {
        const {email, password, isInvalid, email_forgot, notRepeat, new_passwordRepeat, new_password} = this.state
        const {auth} = this.props
        let {t} = this.props
        return (
            <Fragment>
                <BackImage>
                    <Header>
                        <Image src={Logo} alt="Digitalk" width="auto" height="3rem"/>
                        <ul>
                            <li><a href="https://br.linkedin.com/company/digitalk-tecnologia?trk=public_profile_topc" target='_blank' rel="noopener noreferrer"><IconButton><Linkedin fill="#FFF"/></IconButton></a></li>
                            <li><a href="https://www.facebook.com/digitalkTec/" target='_blank' rel="noopener noreferrer"><IconButton><Facebook stroke="#FFF"/></IconButton></a></li>
                            <li><a href="mailto:contato@digitalk.com.br"><IconButton><Email stroke="#FFF"/></IconButton></a></li>
                            <li><a href="https://www.instagram.com/digitalktec/?hl=pt-br" target='_blank' rel="noopener noreferrer"><IconButton><Instagram stroke="#FFF"/></IconButton></a></li>
                        </ul>
                    </Header>
                    <Container height="500px" width="450px">
                        <Image src={LogoLogin} alt="Digitalk"  width="55%" height="auto"/>
                        <ContainerForm>
                            <FormContainer
                                onSubmit={this.handleSubmit}
                                autoComplete={'off'}>
                                <input autoComplete="off" name="hidden" type="text" style={{display:'none'}} />
                                <TextField
                                    ref={el => {
                                        this.emailInput = el
                                    }}
                                    autoComplete={'off'}
                                    id='email'
                                    type='e-mail'
                                    name="email"
                                    isrequired='true'
                                    value={email}
                                    placeholder={t.Form.inputEmail}
                                    autoFocus
                                    errorMessage={('email' in auth && !isInvalid) && auth.email}
                                    onChange={this.handleChange}
                                />
                                <TextField
                                    ref={el => {
                                        this.passwordInput = el
                                    }}
                                    id='password'
                                    name="password"
                                    value={password}
                                    isrequired='true'
                                    autoComplete={'new-password'}
                                    showPassword={true}
                                    errorMessage={('password' in auth && !isInvalid) && auth.password}
                                    placeholder={t.Form.inputPassword}
                                    onChange={this.handleChange}/>
                                <LoginConfig>

                                    {/*<FormControlLabel
                                        classes={{root: 'switch_container'}}
                                        control={<Switch
                                            size="small"
                                            color='primary'
                                            name="keepLoggedIn"
                                            checked={keepLoggedIn}
                                            onChange={this.handleChangeSelect}/>}
                                        labelPlacement="start"
                                        label={t.logged}
                                    />*/}
                                    <Button color='primary' variant='text' type='button' onClick={() => {
                                        /*const email = this.emailInput.state.value
                                        this.emailForgotInput.state.value = email
                                        this.setState({email_forgot: email})*/
                                        this.dialogForgot.handleClickOpen()
                                    }}>{t.Forgot.button}</Button>
                                </LoginConfig>
                                <Button  variant='contained' color='secondary' type='submit'>{t.Form.login}</Button>
                            </FormContainer>
                        </ContainerForm>
                    </Container>


                </BackImage>
                <Dialog  text={<Fragment>
<p>Sistema bloqueado, por favor contate nosso financeiro através do e-mail <a href="mailto:financeiro@digitalk.com.br" target="_parent">financeiro@digitalk.com.br</a> para maiores detalhes.</p></Fragment>} title='Erro no acesso'
                         ref={el => {
                             this.dialogBlocked = el
                         }}/>
                <Dialog id='forgot' title={t.Forgot.title} ref={el => {
                    this.dialogForgot = el
                }}>
                    <Form width="100%" onSubmit={this.handleSubmitForgot}>
                        <TextField
                            ref={el => {
                                this.emailForgotInput = el
                            }}
                            id='email_forgot'
                            name="email_forgot"
                            type='e-mail'
                            isrequired='true'
                            value={email_forgot}
                            errorMessage={('email_forgot' in auth && !isInvalid) && auth.email_forgot}
                            label={t.Form.inputEmail}
                            autoFocus
                            onChange={this.handleChange}/>

                        <div className='flex-end'>
                            <Button type='button' onClick={() => this.dialogForgot.handleClickOpen()} color="primary">
                                {t.Forgot.cancel}
                            </Button>
                            <Button type='submit' color="primary">
                                {t.Forgot.submit}
                            </Button>
                        </div>
                    </Form>
                </Dialog>


                <Dialog id='changePassword' onClose={undefined} text={auth.warning} title={t.ChangePassword.title}
                        ref={el => {
                            this.dialogChangePass = el
                        }}>
                    <Form width="100%" onSubmit={this.handleSubmitChangePass}>
                        {auth.errors && Array.isArray(auth.errors) && auth.errors.map(x => <p>{x}</p>)}
                        {auth.error && <p>{auth.error}</p>}
                        <TextField
                            ref={el => {
                                this.newPasswordInput = el
                            }}
                            id='newPassword'
                            label={t.ChangePassword.inputPassword.label}
                            name="new_password"
                            value={new_password}
                            isrequired='true'
                            type='password'
                            errorMessage={('new_password' in auth && !isInvalid) && auth.new_password}
                            placeholder={t.ChangePassword.inputPassword.placeholder}
                            onChange={this.handleChange}/>
                        <TextField
                            ref={el => {
                                this.passwordRepeatInput = el
                            }}
                            id='password_repeat'
                            label={t.ChangePassword.inputPasswordRepeat.label}
                            name="password_repeat"
                            type='password'
                            value={new_passwordRepeat}
                            isrequired='true'
                            errorMessage={(('password_repeat' in auth && !isInvalid) && auth.password_repeat) ||
                            (notRepeat && t.ChangePassword.inputPasswordRepeat.error)}
                            placeholder={t.ChangePassword.inputPasswordRepeat.placeholder}
                            onChange={this.handleChange}/>


                        <div className='flex-end'>
                            <Button type='submit' color="primary">
                                {t.ChangePassword.inputPasswordRepeat.submit}
                            </Button>
                        </div>
                    </Form>
                </Dialog>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    t: state.i18nState.translations[state.i18nState.lang]["Login"]
})

const mapDispatchToProps = dispatch => ({
    login: (email, password, xThis) => {
        dispatch(userLogin(email, password, xThis))
    },
    loginAD: (token, xThis) => {
        dispatch(userAD(token, xThis))
    },
    logout: () => {
        dispatch(userLogout())
    },
    forgot_password: (email, xThis) => {
        dispatch(forgotPassword(email, xThis))
    },
    first_login: (email,password,newPassword, confirmPassword) => {
        dispatch(firstLogin(email,password,newPassword, confirmPassword))
    },

})


/*function MyComponent() {
    const { t, i18n } = useTranslation('LOGIN', { useSuspense: false });

    useEffect(() => {
        i18n.changeLanguage('en-US');
    });

    return (<Suspense fallback="loading">
        <>{t('FORGOT')}</>
    </Suspense>);
}

export default MyComponent;*/
export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(Login))